<template>
    <div class="pp-radio-group" :class="{'is-inline': inline}">
        <div class="pp-radio__content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
/**
 * 单选组
 * @param {[string, number]} value v-model绑定值
 * @param {[string, number]} label 选中值
 * @param {string} icon 默认图标
 * @param {string} activeIcon 选中图标
 * @param {string} color 选中颜色
 * @param {boolean} disabled 失效状态
 * @param {string} size 尺寸[normal(default), small, mini]
 * @param {string} align 按钮对齐方式 ['right']
 * @param {boolean} inline 行内展示选择项
 * @event change 绑定值改变时触发，参数为改变后的值
 */
export default {
    name: 'pp-radio-group',
    provide: function() {
        return {
            RadioGroup: this,
        };
    },
    inject: {
        Form: {
            default: ''
        },
        FormItem: {
            default: ''
        },
    },
    props: {
        value: [String, Number],
        icon: {
            type: String,
            default: 'pp-icon-circular',
        },
        activeIcon: {
            type: String,
            default: 'pp-icon-radio'
        },
        color: String,
        disabled: Boolean,
        size: {
            type: String,
            default: 'normal',
        },
        inline: Boolean,
        align: {
            type: String,
            validator: function(value) {
                return ['right'].includes(value);
            },
        },
    },
    computed: {
        currentSize: function() {
            return this.Form.size 
                || this.FormItem.size 
                || this.size;
        },
        currentDisabled: function() {
            return this.Form.disabled || this.disabled;
        },
    },
    methods: {
        update: function(val) {
            this.$emit('input', val)
            this.$emit('change', val)
        },
    },

}
</script>
